import { render, staticRenderFns } from "./VuesticMediumEditor.vue?vue&type=template&id=b31226aa"
import script from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
export * from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
import style0 from "./VuesticMediumEditor.vue?vue&type=style&index=0&id=b31226aa&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31226aa')) {
      api.createRecord('b31226aa', component.options)
    } else {
      api.reload('b31226aa', component.options)
    }
    module.hot.accept("./VuesticMediumEditor.vue?vue&type=template&id=b31226aa", function () {
      api.rerender('b31226aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-medium-editor/VuesticMediumEditor.vue"
export default component.exports